<template>
  <div class="mask" v-show="isShow">
    <div class="last" @click="getLastImg">
      <span><img src="@/assets/icons/icon-last.png" alt="" srcset=""></span>
    </div>
    <div class="img" @click.self="isShow = false">
      <img :src="list[index] ? list[index].path : ''" alt="" srcset="">
    </div>
    <div class="next" @click="getNextImg">
      <span><img src="@/assets/icons/icon-next.png" alt="" srcset=""></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImgPreview',
  props: {
    list: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      isShow: false,
      index: 0
    }
  },
  methods: {
    show(index) {
      this.isShow = true
      this.index = index

    },
    getLastImg() {
      if(this.index <= 0) return
      this.index--
    },
    getNextImg() {
      if(this.index >= this.list.length -1) return
      this.index++
    }
  }
}
</script>

<style lang='less' scoped>
.mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.5);
  .last, .next {
    width: 100px;
    height: 100%;
    background-color: #ccc;
    float: left;
    position: relative;
    span {
      position: absolute;
      display: inline-block;
      width: 80px;
      height: 80px;
      top: 50%;
      margin-top: -50%;
      img {
        width: 100%;
        // height: 100%;
      }
    }
  }
  .img {
    width: calc(100% - 200px);
    height: 100%;
    text-align: center;
    float: left;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      max-width: 100%;
      max-height: 100%;
    }
  }
  .next {
  }
}
</style>